// libs
import "babel-polyfill";
import $ from "jquery";
import ScrollMagic from "ScrollMagic";
import { Model } from "backbone";

require("animation.gsap");
require("debug.addIndicators");

// local
import AppBase from "../AppBase";


export default class PageBase extends AppBase {
  constructor() {
    super();
  }

  init() {
    super.init();

    this.initHeaderHide();

    // setTimeout(() => {
    //   $(window).scrollTop(0);
    // }, 100);
  }

  initTopImage() {
    console.log(this.constructor.name, "[initTopImage]");

    const dispatcher  = new Model();
    const $el = $("#js-fadeElement_topImage");
    const bg = $el.css("background-image");
    let urls = bg.match(/^url\("(.+?)"\)$/);

    if (!urls) {
      // safari は(")がつかない
      urls = bg.match(/^url\((.+?)\)$/);
    }

    if (urls) {
      let url = urls[1];
      const image = new Image();
      image.src = url;

      image.onload = () => {
        setTimeout(() => {
          dispatcher.trigger("init");
          $el.removeClass("hide");
          $el.addClass("show");
        }, 30);
      };
    }

    return dispatcher;
  }

  initHeaderColorChange() {
    console.log(this.constructor.name, "[initHeaderColorChange]");

    const controller = new ScrollMagic.Controller();
    const triggerElement = "#js-trigger-logoChange";
    const $stage = $("#js-stage");

    new ScrollMagic.Scene({
      triggerElement: triggerElement,
      reverse: true
    })
      .on("enter", function () {
        // console.log("Scene entered.", $logo);
        $stage.addClass("black");
      })
      .on("leave", function () {
        // console.log("Scene entered.", $logo);
        $stage.removeClass("black");
      })
      // .addIndicators({name: "logoChange"})
      .addTo(controller);
  }

  initHeaderHide() {
    console.log(this.constructor.name, "[initHeaderHide]");

    const controller = new ScrollMagic.Controller();
    const triggerElement = "#js-trigger-logoHide";
    const $header = $("#js-header");

    new ScrollMagic.Scene({
      triggerElement: triggerElement,
      reverse: true
    })
      .on("enter", function () {
        // console.log("Scene entered.", $header);
        $header.addClass("hide");
      })
      .on("leave", function () {
        // console.log("Scene entered.", $header);
        $header.removeClass("hide");
      })
      // .addIndicators({name: "logoHide"})
      .addTo(controller);
  }

  initFadeAnimation() {
    console.log(this.constructor.name, "[initFadeAnimation]");
    const controller = new ScrollMagic.Controller();

    $(".js-fadeElement").each((i, el) => {
      const name = $(el).attr("id").split("_")[1];
      const triggerElement = `#js-trigger-fadeElement_${name}`;

      new ScrollMagic.Scene({
        triggerElement: triggerElement,
        reverse: false
      })
        .on("enter", () => {
          if ($(el).hasClass("hide")) {
            $(el).removeClass("hide");
          }

          $(el).addClass("show");
        })
        // .addIndicators({name: `fade_${name}`})
        .addTo(controller);
    });
  }

  preloadImages() {
    $(".js-preload").each((i, el) => {
      const bg = $(el).css("background-image");
      const urls = bg.match(/^url\("(.+?)"\)$/);

      if (urls) {
        let url = urls[1];
        url = url.replace(/.svg$/, "_hover.svg");
        // console.log(url);
        const img = new Image();
        img.src = url;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/apps/pages/PageBase.js